import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  shiftId: null,
  shiftStartTime: null,
  shiftStartAmount: null,
  isShiftStarted: false,
};

const shiftSlice = createSlice({
  name: "shift",
  initialState,
  reducers: {
    startShift: (state, action) => {
      const { shiftId, startTime, startAmount } = action.payload;

      state.shiftId = shiftId;
      state.shiftStartTime = startTime;
      state.shiftStartAmount = startAmount;
      state.isShiftStarted = true;
    },
    endShift: (state) => {
      state.shiftId = null;
      state.shiftStartTime = null;
      state.shiftStartAmount = null;
      state.isShiftStarted = false;
    },
  },
});

export const { startShift, endShift } = shiftSlice.actions;
export default shiftSlice.reducer;
